module.exports = __webpack_public_path__ + "static/media/banesco-logo.61acb123.png";